// Keep diagnostics in development and avoid dumping response bodies or tokens.
function log(
  level: "log" | "warn" | "error" | "debug" | "info",
  values: unknown[],
): void {
  if (!import.meta.env.DEV) return;
  const messages = values.filter(
    (value): value is string => typeof value === "string",
  );
  const errors = values
    .filter((value): value is Error => value instanceof Error)
    .map((error) => error.message);
  // eslint-disable-next-line no-console -- the single development logging boundary
  console[level](
    ...[...messages, ...errors].map((message) =>
      message
        .replace(
          /([?&](?:token|access_token|id_token)=)[^&#\s]+/gi,
          "$1[redacted]",
        )
        .replace(/Bearer\s+[^\s]+/gi, "Bearer [redacted]"),
    ),
  );
}
export const logger = {
  log: (...values: unknown[]) => log("log", values),
  debug: (...values: unknown[]) => log("debug", values),
  info: (...values: unknown[]) => log("info", values),
  warn: (...values: unknown[]) => log("warn", values),
  error: (...values: unknown[]) => log("error", values),
};
